module.exports = __webpack_public_path__ + "img/m cn 2.62423bbd.gif";